var originTester;
var prepareOriginCheck = function () {
    var matches = location.pathname.match(/index_(\w{2})(_bing|_facebook|_google|_floodlight|_storage)?\.html/);
    if (matches && matches.length > 1) {
        var tld = matches[1];
        originTester = new RegExp(".*.(dm|dm-drogeriemarkt|meindm|mojadm).".concat(tld, "/?$"), 'i');
    }
    else {
        warn('prepareOriginCheck did not find match.');
    }
};
var isValidEvent = function (messageEvent) {
    if ('https://ssl.hurra.com' === (messageEvent === null || messageEvent === void 0 ? void 0 : messageEvent.origin)) {
        return false;
    }
    if (!(originTester === null || originTester === void 0 ? void 0 : originTester.test(messageEvent.origin))) {
        return false;
    }
    if (!messageEvent.data) {
        return false;
    }
    if (JSON.stringify(messageEvent === null || messageEvent === void 0 ? void 0 : messageEvent.data).indexOf('org.chromium.encryptedMessage') >= 0) {
        return false;
    }
    return true;
};
var insertJavaScript = function (scriptUrl, callback) {
    var headElement = document.getElementsByTagName('head')[0];
    var scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.src = scriptUrl;
    headElement.appendChild(scriptElement);
    if (callback) {
        scriptElement.onload = callback;
    }
};
var isProd = function () {
    // check if query string contains p param indicating prod env.
    // param gets set by om-api
    return (/[?&]p(&|$)/.test(window.location.search));
};
var getUrlParameter = function (parameterName) {
    var url = window.location.search;
    var regexCompatibleParameterName = parameterName.replace(/[[\]]/g, '\\$&');
    var parameterValueSearchPattern = new RegExp('[?&]' + regexCompatibleParameterName + '(=([^&#]*)|&|#|$)');
    var results = parameterValueSearchPattern.exec(url);
    if (!results || !results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
var isDbgJa = function () {
    return getUrlParameter('dbg') === 'ja';
};
var dbg = function (message) {
    if (isDbgJa()) {
        // eslint-disable-next-line no-console
        console.log(['SANDBOX: ', message]);
    }
};
var warn = function (message) {
    if (isDbgJa()) {
        // eslint-disable-next-line no-console
        console.warn(['SANDBOX: ', message]);
    }
    import(/* webpackChunkName: "sandboxLogging" */ './logging').then(function (_a) {
        var logWarning = _a.logWarning;
        logWarning(message, isProd());
    });
};
var initIframe = function (messageHandler) {
    prepareOriginCheck();
    window.addEventListener('message', messageHandler, false);
    var iframeId = getUrlParameter('iframeId');
    addEventListener('load', function () {
        dbg("iframe [".concat(iframeId, "] ready"));
        parent.postMessage({ status: 'om iframe ready', iframeId: iframeId }, '*');
    });
};
export { dbg, warn, getUrlParameter, insertJavaScript, isProd, prepareOriginCheck, isValidEvent, initIframe };
//# sourceMappingURL=functions.js.map